'use strict';

define('composer/scrollTimePicker', [], function () {
	const Velocity = ((minInterval = 30, maxInterval = 100) => {
		let _time = 0;
		let _y = 0;
		let _velocity = 0;
		const recorder = {
			record: (y) => {
				const now = +new Date();
				_velocity = (y - _y) / (now - _time);
				if (now - _time >= minInterval) {
					_velocity = now - _time <= maxInterval ? _velocity : 0;
					_y = y;
					_time = now;
				}
			},
			getVelocity: (y) => {
				if (y !== _y) {
					recorder.record(y);
				}
				return _velocity;
			},
		};
		return recorder;
	})();

	function computeChildIndex(top, itemHeight, childrenLength) {
		const index = Math.round(top / itemHeight);
		return Math.min(index, childrenLength - 1);
	}

	const passiveSupported = (() => {
		let passiveSupported = false;

		try {
			const options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: () => {
					passiveSupported = true;
				},
			});
			window.addEventListener('test', null, options);
		} catch (err) { }

		return passiveSupported;
	})();

	function ScrollPickerItem({ el, index, data, select, defaultValue = 0 }) {
		var $root = $(el);
		var rootEl = el;
		var maskEl = $root.find('.picker-item-mask')[0];
		var contentEl = $root.find('.picker-item-content')[0];
		var indicatorEl = $root.find('.picker-item-indicator')[0];

		const rootHeight = rootEl.getBoundingClientRect().height;
		const itemHeight = indicatorEl.getBoundingClientRect().height;
		let num = Math.floor(rootHeight / itemHeight);
		if (num % 2 === 0) {
			num -= 1;
		}
		num -= 1;
		num /= 2;
		contentEl.style.padding = `${itemHeight * num}px 0`;
		indicatorEl.style.top = `${itemHeight * num}px`;
		maskEl.style.backgroundSize = `100% ${itemHeight * num}px`;

		const scrollHandlers = (() => {
			let scrollY = -1;
			let lastY = 0;
			let startY = 0;
			let isMoving = false;

			const setTransform = function (nodeStyle, value) {
				nodeStyle.transform = value;
				nodeStyle.webkitTransform = value;
			};

			const setTransition = function (nodeStyle, value) {
				nodeStyle.transition = value;
				nodeStyle.webkitTransition = value;
			};

			const scrollTo = (_x, y, time = 0.3) => {
				if (scrollY !== y) {
					scrollY = y;
					if (time) {
						setTransition(contentEl.style, `cubic-bezier(0,0,0.2,1.15) ${time}s`);
					}
					setTransform(contentEl.style, `translate3d(0,${-y}px,0)`);
					setTimeout(() => {
						const v = computeChildIndex(y, itemHeight, data[index].length);
						$root.find('.picker-item').removeClass('selected');
						$root.find(`.picker-item:eq(${v})`).addClass('selected');
						select(index, v);
						if (this.contentEl) {
							setTransition(this.contentEl.style, '');
						}
					}, +time * 1000);
				}
			};

			const onFinish = () => {
				isMoving = false;
				let targetY = scrollY;

				const height = (data[index].length - 1) * itemHeight;

				let time = 0.3;

				const velocity = Velocity.getVelocity(targetY) * 4;
				if (velocity) {
					targetY = (velocity * 40) + targetY;
					time = Math.abs(velocity) * 0.1;
				}

				if (targetY % itemHeight !== 0) {
					targetY = Math.round(targetY / itemHeight) * itemHeight;
				}

				if (targetY < 0) {
					targetY = 0;
				} else if (targetY > height) {
					targetY = height;
				}

				scrollTo(0, targetY, time < 0.3 ? 0.3 : time);
			};

			const onStart = (y) => {
				isMoving = true;
				startY = y;
				lastY = scrollY;
			};

			const onMove = (y) => {
				if (!isMoving) {
					return;
				}

				scrollY = lastY - y + startY;
				Velocity.record(scrollY);

				setTransform(contentEl.style, `translate3d(0,${-scrollY}px,0)`);
			};

			return {
				touchstart: evt => onStart(evt.touches[0].pageY),
				mousedown: evt => onStart(evt.pageY),
				touchmove: (evt) => {
					evt.preventDefault();
					onMove(evt.touches[0].pageY);
				},
				mousemove: (evt) => {
					evt.preventDefault();
					onMove(evt.pageY);
				},
				touchend: () => onFinish(),
				touchcancel: () => onFinish(),
				mouseup: () => onFinish(),
				getValue: () => scrollY,
				scrollTo,
			};
		})();

		scrollHandlers.scrollTo(0, itemHeight * defaultValue, 0);
		$root.find('.picker-item').removeClass('selected');
		$root.find(`.picker-item:eq(${defaultValue})`).addClass('selected');

		const willPreventDefault = passiveSupported ? { passive: false } : false;
		const willNotPreventDefault = passiveSupported ? { passive: true } : false;
		Object.keys(scrollHandlers).forEach((key) => {
			if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
				const pd = key.indexOf('move') >= 0 ? willPreventDefault : willNotPreventDefault;
				rootEl.addEventListener(key, scrollHandlers[key], pd);
			}
		});

		this.scrollTo = (i) => {
			scrollHandlers.scrollTo(0, itemHeight * i);
		};
	}

	function ScrollTimePicker({ timeType, value, onChange }) {
		const pickerData = [
			['2025', '2026', '2027'],
			['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
			[],
			timeType === 12 ? ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'] : ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
			[],
		];
		const y = pickerData[0].indexOf(`${value.getFullYear()}`);
		const selectedValue = [y > -1 ? y : 0, value.getMonth(), value.getDate() - 1, value.getHours(), value.getMinutes()];
		for (let i = 0; i < 60; i += 1) {
			pickerData[4].push(`0${i}`.replace(/0(\d{2})/, '$1'));
		}

		if (timeType === 12) {
			pickerData.push(['AM', 'PM']);
			selectedValue.push(selectedValue[3] > 11 ? 1 : 0);
			selectedValue[3] %= 12;
		}

		const pickers = [];

		$('.scroll-multi-picker').html('');
		for (let i = 0; i < pickerData.length; i += 1) {
			let items = '';
			for (let j = 0; j < pickerData[i].length; j += 1) {
				items += `<div class="picker-item">${pickerData[i][j]}</div>`;
			}
			$('.scroll-multi-picker').append(`<div class="picker-item-wrapper"><div class="picker-item-mask"></div><div class="picker-item-indicator"></div><div class="picker-item-scroll"><div class="picker-item-content">${items}</div></div></div>`);
		}

		const pickersEl = $('.picker-item-wrapper');

		const select = (i, j) => {
			if (i === 0 || i === 1) {
				// 年份/月份变更，需要更新日期列表
				const year = parseInt(i === 0 ? pickerData[0][j] : pickerData[0][selectedValue[0]], 10);
				const month = i === 0 ? selectedValue[1] + 1 : j + 1;
				const days = new Date(year, month, 0).getDate();
				// 修正日期选择范围
				if (pickerData[2].length !== days) {
					const dayData = [];
					let items = '';
					for (let ii = 0; ii < days; ii += 1) {
						const l = `0${ii + 1}`.replace(/0(\d{2})/, '$1');
						dayData.push(l);
						items += `<div class="picker-item">${l}</div>`;
					}
					pickerData[2] = dayData;
					$(pickersEl[2]).find('.picker-item-content').html(items);
				}

				// 修正选中日期
				if (selectedValue[2] >= days) {
					selectedValue[2] = days - 1;
					pickers[2].scrollTo(selectedValue[2]);
				}
			}

			selectedValue[i] = j;
			const r = new Date();

			r.setFullYear(+pickerData[0][selectedValue[0]]);
			r.setMonth(selectedValue[1]);
			r.setDate(selectedValue[2] + 1);
			if (timeType === 12) {
				if (selectedValue[5] === 1) {
					r.setHours(selectedValue[3] + 12);
				} else {
					r.setHours(selectedValue[3]);
				}
			} else {
				r.setHours(selectedValue[3]);
			}
			r.setMinutes(selectedValue[4]);
			r.setSeconds(0);
			r.setMilliseconds(0);
			onChange(r);
		};

		for (let i = 0; i < pickersEl.length; i += 1) {
			pickers[i] = new ScrollPickerItem({
				el: pickersEl[i],
				index: i,
				data: pickerData,
				defaultValue: selectedValue[i],
				select,
			});
		}
	}


	return ScrollTimePicker;
});
